import { render, staticRenderFns } from "./ColorableGalleryModal.vue?vue&type=template&id=4806bb9c"
import script from "./ColorableGalleryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorableGalleryModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ColorableGalleryModal.vue?vue&type=style&index=0&id=4806bb9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports